import { Box, Skeleton } from '@mui/material';

// Placeholder for the Top Risky Identities card table: a 35px header and 45px rows of an identity
// (icon + name/type) beside its risk (severity icon + count/caption).
const IdentityCardTableSkeleton = ({ rows = 5, sx }) => (
  <Box sx={{ width: '100%' }}>
    <Box sx={{ display: 'flex', alignItems: 'center', height: '35px', padding: '0 10px', gap: '10px' }}>
      <Skeleton variant="text" width={60} height={16} sx={{ flex: 1, maxWidth: 60, ...sx }} />
      <Box sx={{ flex: 1 }}>
        <Skeleton variant="text" width={50} height={16} sx={sx} />
      </Box>
    </Box>
    {Array.from({ length: rows }).map((_, index) => (
      <Box key={index} sx={{ display: 'flex', alignItems: 'center', height: '45px', padding: '0 10px', gap: '10px' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px', flex: 1, minWidth: 0 }}>
          <Skeleton variant="rounded" width={28} height={28} sx={{ flexShrink: 0, ...sx }} />
          <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1, minWidth: 0 }}>
            <Skeleton variant="text" width="75%" height={18} sx={sx} />
            <Skeleton variant="text" width="50%" height={18} sx={sx} />
          </Box>
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px', flex: 1, minWidth: 0 }}>
          <Skeleton variant="circular" width={18} height={18} sx={{ flexShrink: 0, ...sx }} />
          <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1, minWidth: 0 }}>
            <Skeleton variant="text" width="55%" height={18} sx={sx} />
            <Skeleton variant="text" width="70%" height={18} sx={sx} />
          </Box>
        </Box>
      </Box>
    ))}
  </Box>
);

export default IdentityCardTableSkeleton;
